import React from 'react';
import propTypes from 'prop-types';
import bg from '@bvt-images/authBackground.png';
import moment from 'moment';
import './AuthLayout.scss';
import { SubdomainLogo } from '@bvt-shared/component/SubdomainLogo';
import { useSubdomainInfo } from '@bvt-hooks';

export default function AuthLayout({ children }) {
  const { isBVT } = useSubdomainInfo();
  const currentYear = moment().year();
  const region = process.env.FE_REGION;
  const version = process.env.VERSION;

  return (
    <div className='AuthLayout feature-auth AuthLayout__container'>
      <img
        alt='auth background'
        className='feature-auth AuthLayout__background'
        src={bg}
      />
      <div className='feature-auth AuthLayout__center'>
        <SubdomainLogo
          className={`feature-auth ${
            isBVT
              ? 'AuthLayout__header__logo-li'
              : 'AuthLayout__header__logo'
          }`}
          context='auth'
        />
        <div className='feature-auth AuthLayout__card'>{children}</div>
        <div className='feature-auth AuthLayout__footer'>
          {isBVT ? (
            <>
              <SubdomainLogo
                className='feature-auth AuthLayout__footer__logo-bvt'
                context='footer'
              />
              <div className='feature-auth AuthLayout__footer__copy'>
                © {currentYear} PT. BHUMI VARTA TECHNOLOGY
                {region && <div>{region}</div>}
              </div>
            </>
          ) : (
            <div>
              <div className='feature-auth AuthLayout__footer__version'>
                Version {version}
              </div>
              <SubdomainLogo
                className='feature-auth AuthLayout__footer__logo'
                context='footer'
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

AuthLayout.propTypes = {
  children: propTypes.oneOfType([propTypes.element]),
};
